import uniq from "lodash/uniq";
import { useFormContext } from "react-hook-form";
const useKPI = (props) => {
    const {
        maxKPIAllowed,
        kpiOptions
    } = props;

    const { watch, setValue } = useFormContext();

    const selectedKPI = uniq(watch("kpi"));

    const handleKPI = (value) => {
        const tempKPI = selectedKPI;
        const index = tempKPI?.indexOf(value);
        if (index > -1) {
            tempKPI.splice(index, 1);
        } else {
            tempKPI.push(value);
        }
        setValue("kpi", [...tempKPI], { shouldDirty: true });
    };

    const handleSelectActions = (action) => {
        if (action === "clear") {
            setValue(
                "kpi",
                kpiOptions.filter((item) => item.disabled)?.map((item) => item.value),
                { shouldDirty: true }
            );
        } else {
            if (maxKPIAllowed) {
                setValue(
                    "kpi",
                    kpiOptions
                        .map((item) => item.value)
                        .slice(0, maxKPIAllowed)
                    ,
                    { shouldDirty: true }
                );
            } else {
                setValue(
                    "kpi",
                    kpiOptions.map((item) => item.value)
                    ,
                    { shouldDirty: true }
                );
            }
        }
    };

    return {
        handleSelectActions,
        handleKPI,
        selectedKPI
    };
};

export default useKPI;
